<template>
  <section class="cl-bg-white" >
    <Skeleton v-if="!announcements.length" min-height="120px"/>
    <div class="container announcements-section" v-else>
      <v-row justify="center">
        <v-col cols="12">
          <v-carousel
              height="145"
              hide-delimiter-background
              :hide-delimiters="$vuetify.display.lgAndUp"
              delimiter-icon="$circleMedium"
              cycle
              :show-arrows="$vuetify.display.lgAndUp"
              class="slick-slider announcements-slider">
            <template v-slot:prev="{ props }">
              <i class="icon-angle-right slider-prev"  @click="props.onClick"></i>
            </template>
            <template v-slot:next="{ props }">
              <i class="icon-angle-left slider-next"  @click="props.onClick"></i>
            </template>
            <v-carousel-item v-for="announcement in announcements" :key="'announce-' +announcement.id">
              <div >
                <a :href="announcement.ext_url" class="announcements-card">
                  <img :src="getBannerImages(announcement.img_filename)" :alt="announcement.img_filename">
                </a>
              </div>
            </v-carousel-item>
          </v-carousel>
        </v-col>
      </v-row>
    </div>
  </section>
</template>

<script>
import Skeleton from "@/components/common/Skeleton.vue";
import RepositoryFactory from "@/repositories/RepositoryFactory";
export default {
  components: {Skeleton},
  name: "AnnouncementsSlider",
  data() {
    return {
      AnnouncementRepo: RepositoryFactory.get('Announcement'),
      announcements: '',
    }
  },
  async created() {
    try {
      const { data } = await this.AnnouncementRepo.get();
      this.announcements = data;
    }catch(e)  {
      console.log(e)
    }
    // axios.get(this.$baseUrl + '/announcements_slider').then(response => {
    //   this.announcements = response.data;
    // }).catch(error => {
    //   console.log(error);
    // });
  },
  methods: {
    getBannerImages(image) {
      // return `http://127.0.0.1:8000/uploads/images/announcement/${images}`
      return `${this.$storeFourBaseUrl}/filepond/announcement/${image}`
    }
  }
}
</script>

<style scoped lang="scss">
.announcements-slider {
  .announcements-card{
    width: 100%;
    display: flex !important;
    justify-content: center;
    text-align: center;
  }
  img {
    width: 80%;
    border-radius: 16px;
    @include media-breakpoint-down(md){
      width: 24rem;
    }
  }

  .slider-next:before, .slider-prev:before {
    cursor: pointer;
    top: 50%;
    transform: translateY(-50%);
    color: #989898;
    opacity: 1;
    font-size: 34px;
  }

  .slider-next {
    position: absolute;
    left: 0;
  }
  .slider-prev{
    position: absolute;
    right: 0;
  }


}

</style>
